import React, { Component } from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'
import Button from '@ui/Button'
import RowItem from '@ui/RowItem'

@observer
export default class ButtonsRow extends Component {
  render() {
    const {
      id,
      buttons,
      selected,
      editable,
      onSelect,
      inactive,
      onRemove,
      onChange,
      mode,
      fitContent,
      splitted
    } = this.props

    const buttonsSplitted = splitted ? buttons : [buttons]

    return (
      <RowItem
        id={id}
        editable={editable}
        onRemove={onRemove}
        mode={mode}
        className='vertical'
      >
        {buttonsSplitted.map((row, index) => (
          <div key={index} className={cn('buttons-in-row grow width full', mode)}>
            {row.map((button, index) =>
              button.fake ? (
                <div key={index} className='buttons-in-row__fake-button' />
              ) : (
                <Button
                  key={button.id}
                  id={button.value}
                  onClick={onSelect}
                  primary={button.value === selected}
                  content={button.text}
                  value={button.value}
                  inactive={inactive || button.inactive}
                  editable={button.editable}
                  onChange={onChange}
                  fitContent={fitContent}
                  className={cn({ inverted: button.inverted })}
                  prefix={button.prefix}
                />
              )
            )}
          </div>
        ))}
      </RowItem>
    )
  }
}
